import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { V1_FEATURES } from './v1_adapter';

function SaveButtons(props) {
  const {
    postRequest,
    saveDraft,
    savingState,
    requestStatus,
    size = 'standard',
    saveAndExit,
    abandonChangesAndExit,
    hasCustomSchedule,
  } = props;

  const isSaving = savingState === 'saving';

  // Determine button labels and visibility based on request status
  const isPosted = requestStatus === 'posted';
  const isScheduled = requestStatus === 'scheduled';
  const isLiveRequest = isPosted || isScheduled;

  const buttonClassName = classNames('btn new-request-btn', {
    'btn-sm': size === 'sm',
    'btn-lg': size === 'lg',
  });

  // For live requests (scheduled/posted), show special buttons: Abandon & Exit, Save & Exit
  if (isLiveRequest) {
    return (
      <div className="d-flex gap-2 flex-wrap">
        <button
          className={classNames(buttonClassName, 'btn-outline-secondary flex-grow-0')}
          onClick={abandonChangesAndExit}
          type="button"
        >
          Discard Changes
        </button>
        <button
          className={classNames(buttonClassName, 'btn-primary flex-grow-0')}
          onClick={saveAndExit}
          disabled={isSaving}
          type="button"
        >
          {isSaving && <i className="me-1 fa fa-spinner new-request-ai-spinner" />}
          {isSaving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>
    );
  }

  let primaryButtonLabel;
  if (V1_FEATURES.SKIP_REVIEW_AND_THANKS_PAGES) {
    primaryButtonLabel = hasCustomSchedule ? 'Schedule' : 'Post';
  } else {
    primaryButtonLabel = hasCustomSchedule ? 'Review & Schedule' : 'Review & Post';
  }
  const secondaryButtonLabel = 'Save Changes';

  return (
    <div className="d-flex gap-2 flex-wrap">
      <button
        className={classNames(buttonClassName, 'btn-outline-secondary flex-grow-0')}
        onClick={saveDraft}
        type="button"
      >
        <i
          className={classNames('me-1 fa', {
            'fa-spinner new-request-ai-spinner': isSaving,
            'fa-file-lines': !isSaving,
          })}
        />{' '}
        {isSaving ? 'Saving...' : secondaryButtonLabel}
      </button>

      <button className={classNames(buttonClassName, 'btn-primary flex-grow-0')} onClick={postRequest} type="button">
        {primaryButtonLabel}
      </button>
    </div>
  );
}

SaveButtons.propTypes = {
  hasCustomSchedule: PropTypes.bool,
  postRequest: PropTypes.func.isRequired,
  saveDraft: PropTypes.func.isRequired,
  savingState: PropTypes.string.isRequired,
  requestStatus: PropTypes.oneOf(['draft', 'scheduled', 'posted']),
  size: PropTypes.oneOf(['sm', 'standard', 'lg']),
  saveAndExit: PropTypes.func,
  abandonChangesAndExit: PropTypes.func,
};

SaveButtons.defaultProps = {
  hasCustomSchedule: false,
  requestStatus: 'draft',
  size: 'standard',
  saveAndExit: null,
  abandonChangesAndExit: null,
};

export default SaveButtons;
